import React from "react";

export const CommercialDataTab = () => <div>CommercialDataTab</div>;
